import { SOCIAL_ECOMM } from 'services/actions/socialEcommActions';

export const socialEcommInitialState = {
  team: {
    teamId: null,
    captainShopUserId: null,
    inviteCode: null,
  },
  redeemedMembers: [],
  socialAvatars: [],
  socialAvatarsIds: [],
  inviteModal: {
    isOpen: false,
    product: null,
    experience: null,
  },
  teamCart: {
    cartProducts: {},
    userIds: [],
    cartVariants: [],
  },
  fetchingTeamId: false,
  fetchingTeamIdError: null,
  creatingTeam: false,
  creatingTeamError: null,
  fetchingTeamCarts: false,
  fetchingTeamCartsError: null,
  fetchingTeam: false,
  fetchingInvitationsAndTeam: false,
  invitationsAndTeamError: null,
  fetchingTeamAvatars: false,
  teamAvatarsError: null,
};

export function socialEcommReducer(state = socialEcommInitialState, action) {
  switch (action.type) {
    case SOCIAL_ECOMM.REQUEST_TEAM_ID: {
      return {
        ...state,
        fetchingTeamId: true,
      };
    }
    case SOCIAL_ECOMM.RECEIVE_TEAM_ID: {
      return {
        ...state,
        team: action.team,
        fetchingTeamId: false,
      };
    }
    case SOCIAL_ECOMM.RECEIVE_TEAM_ID_ERROR: {
      return {
        ...state,
        fetchingTeamIdError: action.error,
      };
    }
    case SOCIAL_ECOMM.REQUEST_INVITATIONS_AND_TEAM: {
      return {
        ...state,
        fetchingInvitationsAndTeam: true,
      };
    }
    case SOCIAL_ECOMM.RECEIVE_INVITATIONS_AND_TEAM: {
      return {
        ...state,
        team: {
          ...state.team,
          ...action.team,
        },
        redeemedMembers: action.redeemedMembers,
        fetchingInvitationsAndTeam: false,
      };
    }
    case SOCIAL_ECOMM.RECEIVE_INVITATIONS_AND_TEAM_ERROR: {
      return {
        ...state,
        invitationsAndTeamError: action.error,
      };
    }
    case SOCIAL_ECOMM.REQUEST_TEAM_AVATARS: {
      return {
        ...state,
        fetchingTeamAvatars: true,
      };
    }
    case SOCIAL_ECOMM.RECEIVE_TEAM_AVATARS: {
      return {
        ...state,
        socialAvatars: action.socialAvatars,
        socialAvatarsIds: action.socialAvatarsIds,
        fetchingTeamAvatars: false,
      };
    }
    case SOCIAL_ECOMM.RECEIVE_TEAM_AVATARS_ERROR: {
      return {
        ...state,
        teamAvatarsError: action.error,
      };
    }
    case SOCIAL_ECOMM.CREATE_TEAM: {
      return {
        ...state,
        creatingTeam: true,
      };
    }
    case SOCIAL_ECOMM.CREATE_TEAM_SUCCESS: {
      return {
        ...state,
        creatingTeam: false,
        team: action.team,
      };
    }
    case SOCIAL_ECOMM.CREATE_TEAM_ERROR: {
      return {
        ...state,
        creatingTeamError: action.error,
      };
    }
    case SOCIAL_ECOMM.OPEN_INVITE_MODAL: {
      return {
        ...state,
        inviteModal: {
          isOpen: true,
          experience: action.experience,
        },
      };
    }
    case SOCIAL_ECOMM.OPEN_SHARE_INVITE_MODAL: {
      return {
        ...state,
        inviteModal: {
          isOpen: true,
          product: action.product,
          experience: action.experience,
        },
      };
    }
    case SOCIAL_ECOMM.CLOSE_INVITE_MODAL: {
      return {
        ...state,
        inviteModal: {
          isOpen: false,
          product: null,
          experience: null,
        },
      };
    }
    case SOCIAL_ECOMM.REQUEST_TEAM_CARTS: {
      return {
        ...state,
        fetchingTeamCarts: true,
      };
    }
    case SOCIAL_ECOMM.RECEIVE_TEAM_CARTS: {
      return {
        ...state,
        fetchingTeamCarts: false,
        teamCart: {
          cartProducts: action.cartProducts,
          userIds: action.userIds,
          cartVariants: action.cartVariants,
        },
      };
    }
    case SOCIAL_ECOMM.RECEIVE_TEAM_CARTS_ERROR: {
      return {
        ...state,
        fetchingTeamCarts: false,
        fetchingTeamCartsError: action.error,
      };
    }
    default: {
      return state;
    }
  }
}
